import { imageUrl } from 'utils/filestack';

export function getImageSrc({
  handle,
  width,
  height,
  round,
  fit,
  format,
  mimetype,
  quality,
}: {
  handle: string;
  width?: number;
  height?: number;
  round?: boolean;
  fit?: string;
  format?: string;
  mimetype: string;
  quality?: number;
}) {
  const dimensions = {
    w: width,
    h: height,
  };

  const resize = Object.keys(dimensions)
    .map((key) =>
      dimensions[key] ? `${key}:${Math.round(dimensions[key])}` : ''
    )
    .filter((item) => item.length > 0)
    .join(',');

  return imageUrl({
    handle,
    mimetype,
    transform: `${
      resize.length > 0 ? `resize=${resize}${fit ? `,fit:${fit}` : ''}` : ''
    }/quality=value:${quality || 70}${round ? '/circle' : ''}${
      format ? `/output=format:${format}` : ''
    }`,
  });
}
